import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    carousel:
      'max-md:[--slide-size:auto] max-md:[--slide-spacing:16px] md:[--slide-size:100%]',
    arrowPrev: 'left-6 bg-transparent md:block',
    arrowNext: 'right-6 bg-transparent md:block',
    banner: 'relative w-full',
    image: 'h-45 w-full object-cover max-md:w-auto max-md:max-w-full lg:h-35',
    content:
      'absolute top-1/2 aspect-auto -translate-y-1/2 transform pl-6 max-md:w-[70%] md:pl-20',
    title: 'heading-m-bold md:heading-xl mb-1.5',
    text: 'heading-xs',
    button: 'heading-s-intr-bold mt-1 pl-0 tracking-wider',
    buttonContent: 'flex gap-2',
    advertisingInformer:
      'absolute right-3 bottom-3 z-20 lg:top-3 lg:bottom-auto',
    advertisingInformerContent: 'top-auto bottom-7 lg:top-7 lg:bottom-auto'
  },
  variants: {
    isDarkTheme: {
      true: {
        title: 'text-white',
        text: 'text-white',
        button: 'text-white hover:text-gray-400'
      }
    }
  }
});
